var exports = {
  "Zd": "AddFriendForm.module__form___RWR2dE",
  "kL": "AddFriendForm.module__container___RWR2dE",
  "QX": "AddFriendForm.module__containerDesktop___RWR2dE",
  "hF": "AddFriendForm.module__input___RWR2dE",
  "Rq": "AddFriendForm.module__inputDesktop___RWR2dE",
  "Xu": "AddFriendForm.module__inputError___RWR2dE",
  "x6": "AddFriendForm.module__button___RWR2dE",
  "oR": "AddFriendForm.module__inlineButton___RWR2dE",
  "gJ": "AddFriendForm.module__errorMessage___RWR2dE",
  "Jl": "AddFriendForm.module__successMessage___RWR2dE",
};

module.exports = exports;
